import React, { useEffect, useMemo, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { useUserDetailsContext } from 'context/userDetailsContext';
import constants from 'constants/index';
import { setAppTitle, settingsDropdownOptions } from 'utils/utils';
import useDynamicHeight from 'components/UI/NavbarHeight/useDynamicHeight';
import GlobalTooltip from 'components/GlobalTooltip';
import { ReactComponent as CollapsedIcon } from 'assets/svg/CollapsedIcon.svg';
import { ReactComponent as ExpandedIcon } from 'assets/svg/ExpandedIcon.svg';

const SettingsLayout = (props) => {
  const userDetails = useUserDetailsContext();
  const history = useHistory();
  const location = useLocation();
  const { dynamicHeight } = useDynamicHeight();

  const [isCollapsed, setIsCollapsed] = useState(document.body.classList.contains('sidebar-collapsed'));

  const redirectTo = (e, path) => {
    e.preventDefault();
    history.push('/settings' + path);
  };

  const modifiedSettingsList = useMemo(() => {
    const adminPrivileges = userDetails?.userDetails?.adminPrivileges;
    return settingsDropdownOptions.filter((item) => {
      if (item.value === '/workflow-settings') {
        return userDetails.checkSubPermission('automated_repeatable_workflows');
      } else if (item.value === '/lead-sources') {
        return userDetails.checkSubPermission('lead_management');
      } else if (item.value === '/custom-fields') {
        return userDetails.checkSubPermission('custom_fields');
      } else if (item.value === '/subscription') {
        return !(userDetails?.access_level !== 'firm-admin' && item.value === '/subscription');
      } else if (item?.value === '/quickbooks') {
        return (
          (userDetails?.access_level === 'firm-admin' || adminPrivileges) &&
          item?.value === '/quickbooks' &&
          userDetails?.checkSubPermission('quickbooks_integration')
        );
      } else if (item?.value === '/capture-now-integration') {
        return userDetails?.access_level === 'firm-admin' || adminPrivileges;
      } else if (item?.value === '/request-review-urls') {
        return userDetails.checkSubPermission('request_review');
      } else if (item?.value === '/snippets') {
        return userDetails.checkSubPermission('text_snippets');
      } else return true;
    });
  }, [userDetails?.subscriptionAccess]);

  useEffect(() => {
    return () => document.body.classList.remove('sidebar-collapsed');
  }, []);

  useEffect(() => {
    const pathKey = location?.pathname?.replace('/settings', '');
    const settingOption = modifiedSettingsList.find((option) => option?.value === pathKey);

    setAppTitle('Settings', settingOption?.label || '');

    return () => {
      setAppTitle();
    };
  }, [location?.pathname, modifiedSettingsList]);

  return (
    <div className="container-fluid mt-md-3 pe-0">
      <div className="row pt-1 justify-content-between">
        {userDetails.getFirmPermission(constants.permissions.MANAGE_FIRM_SETTINGS) && (
          <>
            <div className="side-nav shadow-middle d-none d-md-block p-0" style={{ height: `calc(${dynamicHeight} - 25px)` }}>
              <div
                className="pointer sidebar-toggle-icon"
                onClick={() => {
                  document.body.classList.toggle('sidebar-collapsed');
                  setIsCollapsed(!isCollapsed);
                }}
              >
                {isCollapsed ? (
                  <ExpandedIcon style={{ width: 20, height: 20, color: 'var(--black-400)' }} />
                ) : (
                  <CollapsedIcon style={{ width: 20, height: 20, color: 'var(--black-400)' }} />
                )}
              </div>

              <div className="my-3 side-nav-inner">
                {modifiedSettingsList.map((v, i) => {
                  return (
                    <GlobalTooltip key={i} tooltip={isCollapsed && v.label} showDelay={250} position="right">
                      <Link
                        to={`/settings${v.value}`}
                        className={location.pathname === `/settings${v.value}` ? 'current-nav text-decoration-none' : ''}
                      >
                        <i className={location.pathname === `/settings${v.value}` ? v.icon_active : v.icon}></i>
                        <span className="ms-1 menu-label">{v.label}</span>
                      </Link>
                    </GlobalTooltip>
                  );
                })}
              </div>
            </div>

            <Dropdown
              className="d-md-none mb-3"
              options={modifiedSettingsList}
              value={location?.pathname?.replace('/settings', '')}
              onChange={(e) => redirectTo(e, e.target.value)}
              filter
            />
            {/* this is for responsive screen for setting menus */}
          </>
        )}
        <div className="settings-dm" style={{ height: `calc(${dynamicHeight} - 25px)` }}>
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default SettingsLayout;
